import { GRID_DEFAULTS } from './grid-defaults';
/**
 * Completes a step's mobile (`small`) layout with the fields that are only in
 * the desktop (`large`) layout, e.g. fields added on desktop after the mobile
 * layout was saved.
 */ export function completeSmallLayoutItems({ large, small, columns, submitFieldIds = [] }) {
    const placedFieldIds = new Set(small.map(({ fieldId })=>fieldId));
    const submitRows = small.filter(({ fieldId })=>fieldId && submitFieldIds.includes(fieldId)).map(({ row })=>row ?? 0);
    const insertRow = submitRows.length ? Math.max(...submitRows) : Math.max(0, ...small.map(({ row, height })=>(row ?? 0) + (height ?? 1)));
    const unplaced = large.filter(({ fieldId })=>fieldId && !placedFieldIds.has(fieldId)).sort((one, other)=>(one.row ?? 0) - (other.row ?? 0) || (one.column ?? 0) - (other.column ?? 0));
    if (!unplaced.length) {
        return small;
    }
    let row = insertRow;
    const appended = unplaced.map(({ fieldId, height })=>{
        const item = {
            fieldId,
            row,
            column: 0,
            width: columns ?? GRID_DEFAULTS.columns,
            height: height ?? 1
        };
        row += item.height;
        return item;
    });
    const insertedHeight = row - insertRow;
    const shifted = small.map((item)=>(item.row ?? 0) >= insertRow ? {
            ...item,
            row: (item.row ?? 0) + insertedHeight
        } : item);
    return [
        ...shifted,
        ...appended
    ];
}

//# sourceMappingURL=complete-small-layout-items.js.map